/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * API
 * 
  <img src="https://dev-app.yoursafetycompliance.com/assets/images/branding/YSC-logo.png" alt="Safety Compliance" width="150"/>
  <h3>📌 Welcome to the <strong>Your Safety Compliance API Documentation (Admin Module)</strong> 🚀</h3>
  
 * OpenAPI spec version: 1.0
 */

export type GetCompanyListStatus = typeof GetCompanyListStatus[keyof typeof GetCompanyListStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCompanyListStatus = {
  Active: 'Active',
  Inactive: 'Inactive',
} as const;
